<template>
    <div class="is-relative">
        <app-input-image-widget
            v-if="!image"
            :multiple="false"
            @change="setFiles"
        ></app-input-image-widget>
        <img
            v-else
            :ref="'imagePreview'"
            :src="image"
            style="height: 100%; width: 100%; object-fit: contain"
        />
    </div>
</template>

<script>
import AppInputImageWidget from '@/components/AppInputImageWidget';
import { upload } from '@/services/API';
import { EventBus } from '@/services/event-bus';
export default {
    components: {
        AppInputImageWidget,
    },
    model: {
        prop: 'sourceImage',
    },
    props: {
        sourceImage: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    data() {
        return { localImage: null, uploading: false };
    },
    computed: {
        image() {
            return this.sourceImage.url || this.localImage;
        },
    },
    mounted() {
        EventBus.$on('layout:changed', this.emitResize);
    },
    beforeDestroy() {
        // Always destroy your editor instance when it's no longer needed
        this.editor && this.editor.destroy();
        EventBus.$off('layout:changed', this.emitResize);
    },
    methods: {
        emitResize() {
            console.log('image emitting resie', {
                height: this.$refs.imagePreview.height,
                width: this.$refs.imagePreview.width,
            });
            this.$emit('resize', {
                height: this.$refs.imagePreview.height,
                width: this.$refs.imagePreview.width,
            });
        },
        setFiles(files) {
            [...files].forEach((f) => {
                const reader = new FileReader();
                reader.onload = () => {
                    this.localImage = reader.result;
                };
                reader.readAsDataURL(f);
                this.uploadImage(f);
            });
        },
        async uploadImage(file) {
            this.uploading = true;
            let response = await upload(`images`, [file])
                .catch(() => {
                    return this.$emit('error');
                })
                .finally(() => {
                    this.uploading = false;
                });
            if (response.data) {
                this.$emit('input', response.data.images[0]);
                this.$emit('resize', {
                    height: this.$refs.imagePreview.height,
                    width: this.$refs.imagePreview.width,
                });
            }
        },
    },
};
</script>

<style scoped></style>
